import { useState, useMemo } from 'react';
import { chunk, isArray, isEmpty, has, values, isPlainObject } from 'lodash-es';
import { toJSDate } from '../utils/date';


const oneDayMs = 86400000;
const shiftInHalfDay = oneDayMs / 2;

const getWeekends = (series) => {
  const hasSeries = !isEmpty(series);

  const getFirstSeries = (seriesData) => {
    const seriesValue = values(seriesData)[0];

    if (isArray(seriesValue)) return seriesValue;
    if (has(seriesValue, 'series')) return seriesValue.series;
    if (isPlainObject(seriesValue)) return getFirstSeries(seriesValue);
    return [];
  };

  if (hasSeries) {
    const weekendList = [];
    const firstSeries = getFirstSeries(series);
    const isWeekend = day => day === 0 || day === 6;
    const startWithOneWeekend = (day, idx) => day === 0 && idx === 0;
    const endWithOneWeekend = (day, idx) => day === 6 && idx === firstSeries.length - 1;

    firstSeries.forEach(([date], idx) => {
      const day = toJSDate(date).getDay();
      if (startWithOneWeekend(day, idx) || endWithOneWeekend(day)) {
        weekendList.push(date, date);
      } else if (isWeekend(day)) {
        weekendList.push(date);
      }
    });

    return chunk(weekendList, 2).map(([from, to]) => ({
      to: to + shiftInHalfDay,
      from: from - shiftInHalfDay,
      id: from,
      color: '#f5f7fa',
    }));
  }

  return [];
};

const plotBandsEmpty = [];

function useHighlightWeekends(series) {
  const [highlightWeekends, setHighlightWeekends] = useState(false);

  const plotBands = useMemo(() => getWeekends(series), [series]);
  const weekendsOptions = highlightWeekends ? plotBands : plotBandsEmpty;

  return [highlightWeekends, setHighlightWeekends, weekendsOptions];
}

export default useHighlightWeekends;
